import { useEffect, useState } from 'react';
import funcionalidadesApiService from '../services/http/funcionalidadesApiService';
import { PASARELAS } from '../helpers/pasarelas';
import logger from '../services/logger';

// Hook centralizado para saber qué pasarela de pago está activa (Stripe XOR Redsys).
// Usa GET /pasarelaActiva, que devuelve { pasarela: 'stripe' | 'redsys' | null }.

export default function usePasarelaActiva(headquarter) {
  const [pasarela, setPasarela] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    const fetchPasarela = async () => {
      if (!headquarter) {
        setPasarela(null);
        setIsLoading(false);
        return;
      }
      try {
        const data = await funcionalidadesApiService.obtenerPasarelaActiva({ headquarter });
        const raw = typeof data?.pasarela === 'string' ? data.pasarela.toLowerCase() : null;
        if (cancelled) return;
        if (raw === PASARELAS.REDSYS) setPasarela(PASARELAS.REDSYS);
        else setPasarela(PASARELAS.STRIPE);
      } catch (error) {
        logger.error('Error obteniendo pasarela activa:', error);
        if (!cancelled) setPasarela(PASARELAS.STRIPE);
      } finally {
        if (!cancelled) setIsLoading(false);
      }
    };
    fetchPasarela();
    return () => {
      cancelled = true;
    };
  }, [headquarter]);

  return { pasarela, isLoading };
}
